// revu-global/e-fix/components/content/teaser
import React from 'react';

import { MapTo } from '@adobe/aem-react-editable-components';
import striptags from 'striptags';

import { MessageBox } from './MessageBox/MessageBox';

const EditConfig = {
  emptyLabel: 'Title',

  isEmpty(props) {
    return !props || !props.text || props.text.trim().length < 1;
  },
};

const mapProps = (props) => ({
  title: props.title,
  text: striptags(props.description),
  buttonText: props.actions[0]?.title,
  url: props.actions[0]?.url,
});

const Teaser = (props) => <MessageBox data={mapProps(props)} />;

MapTo('e-fix/components/content/teaser')(Teaser, EditConfig);
